import ExcelContainer from "@containers/dashboard/excel";
import DashboardLayout from "@layouts/dashboard";

const ExcelPage = () => {
    return (
        <DashboardLayout title="اکسل">
            <ExcelContainer />
        </DashboardLayout>
    );
};

export default ExcelPage;
